import { Component } from '@angular/core';

@Component({
  selector: 'app-leave-requests',
  templateUrl: './leave-requests.component.html',
  standalone: false,
})
export class LeaveRequestsComponent {}
